import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { array, number, object, string } from "yup";
import { ProductManagementFormValues } from "src/models/ProductManagement.model";
import ProductManagementForm from "../Layouts/ProductManagement";
import {
  useGetProductManagementByIdQuery,
  useUpdateProductManagementByIdMutation,
} from "src/services/ProductManagementService";
import { CircularProgress } from "@mui/material";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
  selectedProductManagementId: string;
};

const EditProductManagementFormWrapper = ({
  onClose,
  selectedProductManagementId,
}: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } = useGetProductManagementByIdQuery(
    selectedProductManagementId
  );
  const [updateFacultyById] = useUpdateProductManagementByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);
  const initialValues: ProductManagementFormValues = {
    title: items.title || "",
    description: items.description || "",
    variants: items.variants?.map((variant: any) => ({
      price: variant.price || "",
      modeId: { label: variant.mode, value: variant.modeId } || "",
      batchRecording:variant.batchRecording,
      noOfViews: variant.noOfViews || "",
    })),
    books:
      items.books?.map((book: any) => ({
        label: book.bookName,
        value: book.bookId,
      })) || [],
    images: items.images || [],
  };

  // Validation Schema
  const validationSchema = object().shape({
    title: string().required("Please enter title"),
    description: string(),
    variants: array().of(
      object({
        price: number()
          .min(0, "Please enter more then zero")
          .required("Please enter amount fees"),
        modeId: object().required("Please select mode"),
        noOfViews: string(),
        batchRecording: string(),
          // .min(0, "Please enter more then zero")
          // .required("Please enter views"),
      })
    ),
    books: array().required("Please select book"),
    images: array().of(string()),
  });

  // Handle Submit
  const handleSubmit = (
    values: ProductManagementFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ProductManagementFormValues>
  ) => {
    const formattedValues = {
      title: values.title,
      variants: values.variants.map((variant) => ({
        price: variant.price,
        modeId: variant.modeId.value,
        noOfViews: variant.noOfViews,
        batchRecording:variant.batchRecording
      })),
      books: values.books.map((book) => book.value),
      images: values.images,
      description: values.description,
    };
    updateFacultyById({
      id: selectedProductManagementId,
      body: formattedValues,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="md" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <ProductManagementForm
              formikProps={formikProps}
              onClose={onClose}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditProductManagementFormWrapper;
